var _get = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var AbstractEndpoint = require('../endpoint');

module.exports =
/*#__PURE__*/
function (_AbstractEndpoint) {
  "use strict";

  _inherits(PvpEndpoint, _AbstractEndpoint);

  function PvpEndpoint(client, fromAccount) {
    var _this;

    _classCallCheck(this, PvpEndpoint);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PvpEndpoint).call(this, client));
    _this.fromAccount = fromAccount;
    return _this;
  }

  _createClass(PvpEndpoint, [{
    key: "amulets",
    value: function amulets() {
      return new AmuletsEndpoint(this);
    }
  }, {
    key: "games",
    value: function games() {
      return new GamesEndpoint(this);
    }
  }, {
    key: "heroes",
    value: function heroes() {
      if (this.fromAccount) {
        return new AccountHeroesEndpoint(this);
      }

      return new HeroesEndpoint(this);
    }
  }, {
    key: "ranks",
    value: function ranks() {
      return new RanksEndpoint(this);
    }
  }, {
    key: "seasons",
    value: function seasons(id) {
      return new SeasonsEndpoint(this, id);
    }
  }, {
    key: "standings",
    value: function standings() {
      return new StandingsEndpoint(this);
    }
  }, {
    key: "stats",
    value: function stats() {
      return new StatsEndpoint(this);
    }
  }]);

  return PvpEndpoint;
}(AbstractEndpoint);

var AccountHeroesEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint2) {
  "use strict";

  _inherits(AccountHeroesEndpoint, _AbstractEndpoint2);

  function AccountHeroesEndpoint(client) {
    var _this2;

    _classCallCheck(this, AccountHeroesEndpoint);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(AccountHeroesEndpoint).call(this, client));
    _this2.url = '/v2/account/pvp/heroes';
    _this2.isAuthenticated = true;
    _this2.cacheTime = 5 * 60;
    return _this2;
  }

  return AccountHeroesEndpoint;
}(AbstractEndpoint);

var AmuletsEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint3) {
  "use strict";

  _inherits(AmuletsEndpoint, _AbstractEndpoint3);

  function AmuletsEndpoint(client) {
    var _this3;

    _classCallCheck(this, AmuletsEndpoint);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(AmuletsEndpoint).call(this, client));
    _this3.url = '/v2/pvp/amulets';
    _this3.isPaginated = true;
    _this3.isBulk = true;
    _this3.isLocalized = true;
    _this3.cacheTime = 24 * 60 * 60;
    return _this3;
  }

  return AmuletsEndpoint;
}(AbstractEndpoint);

var GamesEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint4) {
  "use strict";

  _inherits(GamesEndpoint, _AbstractEndpoint4);

  function GamesEndpoint(client) {
    var _this4;

    _classCallCheck(this, GamesEndpoint);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(GamesEndpoint).call(this, client));
    _this4.url = '/v2/pvp/games';
    _this4.isPaginated = true;
    _this4.isBulk = true;
    _this4.isAuthenticated = true;
    _this4.cacheTime = 5 * 60;
    return _this4;
  }

  return GamesEndpoint;
}(AbstractEndpoint);

var HeroesEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint5) {
  "use strict";

  _inherits(HeroesEndpoint, _AbstractEndpoint5);

  function HeroesEndpoint(client) {
    var _this5;

    _classCallCheck(this, HeroesEndpoint);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(HeroesEndpoint).call(this, client));
    _this5.url = '/v2/pvp/heroes';
    _this5.isPaginated = true;
    _this5.isBulk = true;
    _this5.isLocalized = true;
    _this5.cacheTime = 24 * 60 * 60;
    return _this5;
  }

  return HeroesEndpoint;
}(AbstractEndpoint);

var RanksEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint6) {
  "use strict";

  _inherits(RanksEndpoint, _AbstractEndpoint6);

  function RanksEndpoint(client) {
    var _this6;

    _classCallCheck(this, RanksEndpoint);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(RanksEndpoint).call(this, client));
    _this6.url = '/v2/pvp/ranks';
    _this6.isPaginated = true;
    _this6.isBulk = true;
    _this6.isLocalized = true;
    _this6.cacheTime = 24 * 60 * 60;
    return _this6;
  }

  return RanksEndpoint;
}(AbstractEndpoint);

var SeasonsEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint7) {
  "use strict";

  _inherits(SeasonsEndpoint, _AbstractEndpoint7);

  function SeasonsEndpoint(client, id) {
    var _this7;

    _classCallCheck(this, SeasonsEndpoint);

    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(SeasonsEndpoint).call(this, client));
    _this7.id = id;
    _this7.url = '/v2/pvp/seasons';
    _this7.isPaginated = true;
    _this7.isBulk = true;
    _this7.isLocalized = true;
    _this7.cacheTime = 24 * 60 * 60;
    return _this7;
  }

  _createClass(SeasonsEndpoint, [{
    key: "leaderboards",
    value: function leaderboards() {
      return new SeasonLeaderboardEndpoint(this, this.id);
    }
  }]);

  return SeasonsEndpoint;
}(AbstractEndpoint);

var SeasonLeaderboardEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint8) {
  "use strict";

  _inherits(SeasonLeaderboardEndpoint, _AbstractEndpoint8);

  function SeasonLeaderboardEndpoint(client, id) {
    var _this8;

    _classCallCheck(this, SeasonLeaderboardEndpoint);

    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(SeasonLeaderboardEndpoint).call(this, client));
    _this8.id = id;
    _this8.url = "/v2/pvp/seasons/".concat(id, "/leaderboards");
    _this8.cacheTime = 24 * 60 * 60;
    return _this8;
  }

  _createClass(SeasonLeaderboardEndpoint, [{
    key: "ids",
    value: function ids() {
      return _get(_getPrototypeOf(SeasonLeaderboardEndpoint.prototype), "get", this).call(this, '', true);
    }
  }, {
    key: "board",
    value: function board(_board, region) {
      return new SeasonLeaderboardBoardEndpoint(this, this.id, _board, region);
    }
  }]);

  return SeasonLeaderboardEndpoint;
}(AbstractEndpoint);

var SeasonLeaderboardBoardEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint9) {
  "use strict";

  _inherits(SeasonLeaderboardBoardEndpoint, _AbstractEndpoint9);

  function SeasonLeaderboardBoardEndpoint(client, id, board, region) {
    var _this9;

    _classCallCheck(this, SeasonLeaderboardBoardEndpoint);

    _this9 = _possibleConstructorReturn(this, _getPrototypeOf(SeasonLeaderboardBoardEndpoint).call(this, client));
    _this9.url = "/v2/pvp/seasons/".concat(id, "/leaderboards/").concat(board, "/").concat(region);
    _this9.isPaginated = true;
    _this9.cacheTime = 5 * 60;
    return _this9;
  }

  return SeasonLeaderboardBoardEndpoint;
}(AbstractEndpoint);

var StandingsEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint10) {
  "use strict";

  _inherits(StandingsEndpoint, _AbstractEndpoint10);

  function StandingsEndpoint(client) {
    var _this10;

    _classCallCheck(this, StandingsEndpoint);

    _this10 = _possibleConstructorReturn(this, _getPrototypeOf(StandingsEndpoint).call(this, client));
    _this10.url = '/v2/pvp/standings';
    _this10.isAuthenticated = true;
    _this10.cacheTime = 5 * 60;
    return _this10;
  }

  return StandingsEndpoint;
}(AbstractEndpoint);

var StatsEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint11) {
  "use strict";

  _inherits(StatsEndpoint, _AbstractEndpoint11);

  function StatsEndpoint(client) {
    var _this11;

    _classCallCheck(this, StatsEndpoint);

    _this11 = _possibleConstructorReturn(this, _getPrototypeOf(StatsEndpoint).call(this, client));
    _this11.url = '/v2/pvp/stats';
    _this11.isAuthenticated = true;
    _this11.cacheTime = 5 * 60;
    return _this11;
  }

  return StatsEndpoint;
}(AbstractEndpoint);